/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/react';
import { primary, white } from 'styles/global_defaults/colors';

export const optionStyles = css`
  background: ${primary};
  color: ${white};
  border-radius: 50%;
  padding: 4px;
`;
